// extracted by mini-css-extract-plugin
module.exports = {"delete":"RemoveItemButton__delete___1H487"};